import { patchState, signalStoreFeature, withMethods, withState } from '@ngrx/signals';
import { ConstructionProjectFeaturesType } from '@construction/models/construction-project.model';
import { defaultFeaturePermissions } from './state';

/** Owns `features` (raw feature flag list) and `featurePermission` (derived access map). */
export function withFeatureFlags() {
  return signalStoreFeature(
    withState({
      features: [] as ConstructionProjectFeaturesType[],
      featurePermission: { ...defaultFeaturePermissions },
    }),
    withMethods((store) => ({
      updateFeatureFlags(features: ConstructionProjectFeaturesType[]): void {
        patchState(store, { features });
      },
    })),
  );
}
